import { Partner } from 'projects/PartnerContext';
import React from 'react';

export default function PartnerLogo({ partner }: { partner: Partner }) {
    switch (partner) {
        case Partner.NationBuilder:
            return (
                <img
                    src={require('images/projects/create/partners/nationbuilder.png')}
                    width={160}
                />
            );
        case Partner.Square:
            return (
                <img
                    src={require('images/projects/create/partners/square-wordmark.svg')}
                    width={120}
                />
            );
        default:
            return null;
    }
}
